import deployments from './deployments';
import settings from './settings';
import trials from './trials';
import units from './units';

const menuItems = {
    items: [deployments, trials, units, settings]
};

export default menuItems;
